import React from 'react';

import {
    getMatchTypeIndicator,
} from '../../../utils';
import links from '../../../../config/links';
import Img from '../../Img';
import { ratingTypes } from '../../../utils/constants';

export const ratingStatusPopUpData = {
    unrated: {
        title: 'Unrated',
        description: 'This player has not played any matches or had a rating in the past year.',
    },
    inactive: {
        title: 'Inactive Rating',
        description: 'This player has not played any matches in the past 12 months. Their rating is the last time they had a rating on UTR Sports.',
    },
    projected: {
        title: 'Projected (P) Rating',
        description: 'This player hasn’t played enough matches in the last 12 months for their rating to be reliable. It usually takes 6-10 matches to get a reliable rating, depending on the reliability of your opponent and how close the score was.',
    },
};

export const verifiedStatusData = {
    verified: {
        title: `Verified ${ratingTypes.tennis}`,
        description: 'Reflects results from only Verified events.',
    },
    unverified: {
        title: `${ratingTypes.tennis}`,
        description: 'Reflects your results from any event, including casual play, verified matches, and self-posted scores.',
    },
};

export const matchTypeData = {
    singles: {
        title: 'Singles Rating',
        description: 'Reflects results from singles matches.',
    },
    doubles: {
        title: 'Doubles Rating',
        description: 'Reflects results from doubles matches.',
    },
};

class RatingInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMenuShowed: false,
            displayMenuBelowAnchor: true,
        };
        this.handleAchorClick = this.handleAchorClick.bind(this);
        this.closePopUp = this.closePopUp.bind(this);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
        document.removeEventListener('touchend', this.handleClickOutside, false);
    }

    handleAchorClick(ev) {
        ev.stopPropagation();
        ev.preventDefault();

        // width reduced for Iphone 5 and small resolution devices
        let width = 300;
        if (window.innerWidth > 500) {
            width = 400;
        }

        // Values from left border
        let right = false;
        let transformValue = 'translateX(-50%)';
        let distanceFromBorder = ev.nativeEvent.clientX;

        if (ev.nativeEvent.clientX > window.innerWidth / 2) {
            // Values from right border
            right = true;
            distanceFromBorder = window.innerWidth - ev.nativeEvent.clientX;
            transformValue = 'translateX(50%)';
        }

        if (distanceFromBorder < width / 2) {
            if (right) {
                transformValue = `translateX(${distanceFromBorder}px)`;
            } else {
                transformValue = `translateX(${-distanceFromBorder}px)`;
            }
        }

        if (this.props.translateXValue) {
            transformValue = `translateX(${this.props.translateXValue})`;
        }

        let showBelow = true;
        if (ev.nativeEvent.clientY > (2 * window.innerHeight / 3)) {
            showBelow = false;
        }
        this.setState({
            isMenuShowed: true,
            displayMenuBelowAnchor: showBelow,
            hoverWidth: `${width}px`,
            rightAlign: right,
            transformValue,
        });
    }

    closePopUp() {
        this.setState({
            isMenuShowed: false,
        });
    }

    render() {
        const { rating } = this.props;

        const ratingStatusInfo = ratingStatusPopUpData[`${(rating && rating.status) ? rating.status.toLowerCase() : ''}`];
        const matchTypeInfo = matchTypeData[`${(rating && rating.matchType) ? rating.matchType.toLowerCase() : ''}`];
        const verifiedInfo = verifiedStatusData[`${(rating && rating.verified) ? 'verified' : 'unverified'}`];

        const PopUp = () => {
            return (
                <div
                    className={`rating-pop-up`}
                >
                    <div className="gradient-bar" />
                    <div className="pop-up-content">
                        {verifiedInfo && (
                            <React.Fragment>
                                <h5 className={`text ${rating.verified ? 'verified' : ''}`}>{verifiedInfo.title}</h5>
                                <p className="text">{verifiedInfo.description}</p>
                                <br />
                            </React.Fragment>
                        )}
                        {ratingStatusInfo && (
                            <React.Fragment>
                                <h5 className="text">{ratingStatusInfo.title}</h5>
                                <p className="text">{ratingStatusInfo.description}</p>
                                <br />
                            </React.Fragment>
                        )}
                        {matchTypeInfo && (
                            <React.Fragment>
                                <h5 className="text">
                                    {matchTypeInfo.title}
                                    {getMatchTypeIndicator(rating)}
                                </h5>
                                <p className="text">{matchTypeInfo.description}</p>
                                <br />
                            </React.Fragment>
                        )}
                        <p className="text">See <a href={links.algorithmUnderstandingLink} rel="noopener noreferrer" target="_blank">Understanding the Algorithm</a> to learn more</p>
                        <a
                            onClick={() => {
                                this.closePopUp();
                            }}
                            className={`btn btn-default btn-block text-uppercase`}
                        >
                            <span>{this.props.cancelText}</span>
                        </a>
                    </div>
                </div>
            );
        };

        return (
            <div className={`info-root ${this.props.rootClass ? this.props.rootClass : ''}`}>
                <Img
                    alt="tooltip"
                    src="/img/info-icon.svg"
                    className={`info-anchor ${this.props.anchorClass ? this.props.anchorClass : ''}`}
                    onClick={this.handleAchorClick}
                />
                {this.state.isMenuShowed && (
                    <div className="action-click-disabler" />
                )}
                <div
                    className={`info-container ${this.state.displayMenuBelowAnchor ? 'below-anchor' : 'above-anchor'} ${this.props.menuClass ? this.props.menuClass : ''}`}
                    style={this.state.rightAlign ? {
                        width: this.state.hoverWidth,
                        right: '15px',
                        transform: this.state.transformValue,
                    } : {
                        width: this.state.hoverWidth,
                        left: '30px',
                        transform: this.state.transformValue,
                    }}
                >
                    {this.state.isMenuShowed && (
                        <PopUp />
                    )}
                </div>
            </div>

        );
    }
}

export default RatingInfo;
